import { render, staticRenderFns } from "./PlanFacturacion.vue?vue&type=template&id=6f85b956&"
import script from "./PlanFacturacion.vue?vue&type=script&lang=js&"
export * from "./PlanFacturacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports